function updateZones(id) {
    var zones = jQuery("#zones").val();

    if (zones.length === 0) {
        zones = [];
    } else {
        zones = zones.split(',');
    }

    var index = zones.indexOf(id + "");
    var exists = index !== -1;
    if (!exists) {
        zones.push(id);
    } else {
        zones.splice(index, 1);
    }

    jQuery("#zones").val(zones.join(','));
    jQuery("#zones").parents('form:first').trigger('change');
}

function toggleArea(id) {
    jQuery("#head-left-" + id).toggle();
    jQuery("#head-top-" + id).toggle();
    jQuery("#head-back-" + id).toggle();

    updateZones(id);

    var zoneSelector = jQuery("#zone-" + id);
    var zones = $('#zones').val().replace(/^,+/, '').replace(/,+$/, '').split(',');
    if(jQuery.inArray(zoneSelector.val(), zones) === -1) {
        // item NOT in Array
        zoneSelector.prop('checked', false);
    } else {
        zoneSelector.prop('checked', true);
    }

    return false;
}

(function ($) {
    $(document).ready(function () {
        setTimeout(function () {
            if ($('#zones').length) {
                var zones = $('#zones').val().replace(/^,+/, '').replace(/,+$/, '').split(',');
                $('#zones').val('');
                for (x in zones) {
                    toggleArea(zones[x]);
                    $("#zone-" + zones[x]).prop('checked', true);
                }
            }
        }, 500);
    });
})(jQuery);

(function ($) {
    jQuery(document).ready(function () {
        $('form').change(function (event) {
            var element = event.srcElement, value;

            $('.feriduni-head-maps input, .feriduni-head-maps select, .feriduni-head-maps textarea').each(function (index, element) {

                hidden = 'hidden' == element.type && 'zones' !== element.id;

                if ('language' !== element.name && 'submit' !== element.type && !hidden) {
                    if ('radio' === element.type || 'checkbox' === element.type) {
                        value = $(element).is(':checked');
                    } else {
                        value = $(element).val();
                    }

                    localStorage.setItem(element.id, value);
                }
            });
        }).submit(function () {
            $('input, select, textarea').each(function (index, element) {
                localStorage.removeItem(element.id);
            });

            $(this).submit();
        });

        $('.feriduni-head-maps input, .feriduni-head-maps select, .feriduni-head-maps textarea').each(function (index, element) {
            var value = localStorage.getItem(element.id);

            if (value != null) {
                if ('radio' === element.type || 'checkbox' === element.type) {
                    if ('true' === value) {
                        $(element).attr('checked', 'checked');
                    } else {
                        $(element).removeAttr('checked');
                    }
                } else {
                    $(element).val(value);
                }
            }
        });
    });
})(jQuery);
